import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  Inject,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormArray
} from '@angular/forms';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { ValidateService } from '../../../services/validate.service';
import { Cnae, Combo } from '../../../models/combo';
import { CombosService } from '../../../services/combos.service';
import {
  GestoresResiduosControllerService,
  GestoresResiduosDTO,
  GestoresConAcuerdoControllerService,
  GestoresConAcuerdoFilterDTO,
  Pageable,
} from 'api-rest';
import { DatePipe } from '@angular/common';
import moment from 'moment';

@Component({
  selector: 'lib-waste-managers-detail-general-data',
  templateUrl: './waste-managers-detail-general-data.component.html',
  styleUrls: ['./waste-managers-detail-general-data.component.scss'],
})
export class WasteManagersDetailGeneralDataComponent implements OnInit {
  @Input() gestorInfo!: any;
  @Output() public refrescarGestorEvent = new EventEmitter<any>();

  datosGeneralesForm!: FormGroup;
  tiposDocumento: Combo[] = [];

  updateList: boolean = false;
  flagDisabledForm: boolean = false;

  //abonosDeposito: any[] = [];

  optionArray = [{ value: 'Si' }, { value: 'No' }];
  firmaObligatoria: boolean = false;
  constructor(
    public spinnerSrv: SpinnerService,
    private formBuilder: FormBuilder,
    @Inject('environment') private environment: any,
    private snackBarSrv: SnackbarService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    private validateSrv: ValidateService,
    public comboSrv: CombosService,
    private gestoresResiduosControllerService: GestoresResiduosControllerService,
    private gestoresConAcuerdoControllerService: GestoresConAcuerdoControllerService,
    private datePipe: DatePipe
  ) {
    this.datosGeneralesForm = this.formBuilder.group({
      razonSocial: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(255)]) },
      ],
      tipoDocumento: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      codigoDocumento: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(15)]) },
      ],
      nima: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.required,
            Validators.pattern(this.validateSrv.nimaPattern),
            Validators.maxLength(10)]
          )
        },
      ],
      denominacion: [{ value: null, disabled: false }, Validators.maxLength(255)],
      n_medioAmbiente: [{ value: null, disabled: false }, Validators.maxLength(255)],
      n_inscrip_1: [
        { value: null, disabled: false },
      ],
      n_inscrip_2: [{ value: null, disabled: false }, Validators.maxLength(255)],
      n_inscrip_3: [{ value: null, disabled: false }, Validators.maxLength(255)],
      n_inscrip: this.formBuilder.array([]),
      fechaAltaFinalizada: [{ value: null, disabled: true }],
      fechaBaja: [{ value: null, disabled: false }],
      fechaBajaEnvanet: [{ value: null, disabled: true }],
      acuerdoEnv: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      convenioEnvalora: [{ value: null, disabled: false }],
      fechaFinConvenio: [{ value: null, disabled: false }],
      fechaFirmaConvenio: [{ value: null, disabled: false }],
      gestorResiduos: [{ value: null, disabled: false }],
      acondicionador: [{ value: null, disabled: false }],
      abonoDeposito: [
        { value: null, disabled: false }
      ],
      autorizacionComuniaciones: [
        { value: true, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      cargaMasiva: [
        { value: true, disabled: false },
      ],
    },
    { validators: [this.gestorAcondicionadorValidator()] }

  );
  }

  ngOnInit() {
    this.tiposDocumento = this.comboSrv.getTiposDocumentoIdentidad();
    //this.abonosDeposito = this.comboSrv.getAbonosDeposito();
    this.datosGeneralesForm.get('acuerdoEnv')?.disable();
    this.updateAcondicionadorEditability();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.gestorInfo) {
      this.cargarDatos(this.gestorInfo);
      this.controlGeneralForm();
    }

  }

  cargarDatos(gestorInfo: any) {
    this.datosGeneralesForm
      .get('razonSocial')
      ?.setValue(gestorInfo?.razonSocial);
    this.datosGeneralesForm
      .get('tipoDocumento')
      ?.setValue(gestorInfo?.tipoDocumento);
    this.datosGeneralesForm
      .get('codigoDocumento')
      ?.setValue(gestorInfo?.codigoDocumento);
    this.datosGeneralesForm.get('nima')?.setValue(gestorInfo?.nima);
    this.datosGeneralesForm.get('denominacion')?.setValue(gestorInfo?.centro);
    this.datosGeneralesForm
      .get('n_medioAmbiente')
      ?.setValue(gestorInfo?.numeroAutorizacion);
    this.datosGeneralesForm
      .get('n_inscrip_1')
      ?.setValue(gestorInfo?.numInscripcion1);
    this.datosGeneralesForm
      .get('n_inscrip_2')
      ?.setValue(gestorInfo?.numInscripcion2);
    this.datosGeneralesForm
      .get('n_inscrip_3')
      ?.setValue(gestorInfo?.numInscripcion3);
    let fechaAltaFinalizada =
      gestorInfo?.fechaAltaFinalizada != null
        ? this.datePipe.transform(gestorInfo?.fechaAltaFinalizada, 'dd/MM/yyyy')
        : null;
    this.datosGeneralesForm
      .get('fechaAltaFinalizada')
      ?.setValue(fechaAltaFinalizada);
    this.datosGeneralesForm.get('fechaBaja')?.setValue(gestorInfo?.fechaBaja);
    let fechaBajaEvanet =
      gestorInfo?.fechaBajaEnvanet != null
        ? this.datePipe.transform(gestorInfo?.fechaBajaEnvanet, 'dd/MM/yyyy')
        : null;
    this.datosGeneralesForm
      .get('fechaBajaEnvanet')
      ?.setValue(fechaBajaEvanet);
    this.tipoDocumentoSel(this.datosGeneralesForm.get('tipoDocumento')?.value);
    this.datosGeneralesForm
    .get('acuerdoEnv')
      ?.setValue(
        gestorInfo?.acuerdoEnvalora === true
          ? 'Si'
          : gestorInfo?.acuerdoEnvalora === false
            ? 'No'
            : null
      );
      this.datosGeneralesForm
      .get('convenioEnvalora')
      ?.setValue(
        gestorInfo?.convenioEnvalora === true
          ? 'Si'
          : 'No'

      );
      if(gestorInfo?.convenioEnvalora === true){
        this.firmaObligatoria = true;
      }else{
        this.firmaObligatoria = false;
      }
      this.datosGeneralesForm.get('fechaFinConvenio')?.setValue(gestorInfo?.fechaFinConvenio);
      this.datosGeneralesForm.get('fechaFirmaConvenio')?.setValue(gestorInfo?.fechaFirmaConvenio);
      // Asegurar que los validadores relacionados con el convenio se apliquen tras cargar el valor
      this.onConvenioChange(null);
    if(gestorInfo?.gestorResiduos != null){
      this.datosGeneralesForm
      .get('gestorResiduos')
      ?.setValue(gestorInfo?.gestorResiduos);
    } else{
      this.datosGeneralesForm
      .get('gestorResiduos')
      ?.setValue(false);
    }
    if(gestorInfo?.acondicionadorEnvase != null){
      this.datosGeneralesForm
      .get('acondicionador')
      ?.setValue(gestorInfo?.acondicionadorEnvase);
    } else{
      this.datosGeneralesForm
      .get('acondicionador')
      ?.setValue(false);
    }
    this.datosGeneralesForm.get('cargaMasiva')?.setValue(gestorInfo?.cargaMasiva);
    this.cargarDatosNInscript(gestorInfo?.numerosInscripcionAdicionales);
    this.onGestorAcondicionadorChange();
    this.datosGeneralesForm.get('abonoDeposito')?.setValue(gestorInfo?.abonoDeposito);
    if(gestorInfo?.autorizacionComuniaciones != null && gestorInfo?.autorizacionComuniaciones != undefined){
      this.datosGeneralesForm.get('autorizacionComuniaciones')?.setValue(gestorInfo?.autorizacionComuniaciones);
    }else{
      this.datosGeneralesForm.get('autorizacionComuniaciones')?.setValue(null);
    }
  }

  guardar() {
    this.datosGeneralesForm.markAllAsTouched();
    this.datosGeneralesForm.updateValueAndValidity();
    if (this.datosGeneralesForm.valid) {
      let body = structuredClone(this.gestorInfo);

      /**if((this.datosGeneralesForm.get('gestorResiduos')?.dirty || this.datosGeneralesForm.get('acondicionador')?.dirty) &&
        (this.datosGeneralesForm.get('gestorResiduos')?.value === true || this.datosGeneralesForm.get('acondicionador')?.value === true)){
        body.gestoresResiduosEstado.id = 1;
      }**/
      body.razonSocial = this.datosGeneralesForm.get('razonSocial')?.value ? this.datosGeneralesForm.get('razonSocial')?.value.trim() : null;

      body.tipoDocumento = this.datosGeneralesForm.get('tipoDocumento')?.value;

      body.codigoDocumento =
        this.datosGeneralesForm.get('codigoDocumento')?.value;

      body.nima = this.datosGeneralesForm.get('nima')?.value;

      body.centro = this.datosGeneralesForm.get('denominacion')?.value ? this.datosGeneralesForm.get('denominacion')?.value.trim() : null;

      body.numeroAutorizacion =
        this.datosGeneralesForm.get('n_medioAmbiente')?.value;
      body.numInscripcion1 = this.datosGeneralesForm.get('n_inscrip_1')?.value;
      body.numInscripcion2 = this.datosGeneralesForm.get('n_inscrip_2')?.value;

      body.numInscripcion3 = this.datosGeneralesForm.get('n_inscrip_3')?.value;

      body.fechaAltaFinalizada = this.gestorInfo?.fechaAltaFinalizada;
      body.fechaBajaEnvanet = this.gestorInfo?.fechaBajaEnvanet;

      //Si esta vacio se le envia como false, para las validaciones, estas comprueban que el valor sea false.
      if(this.datosGeneralesForm.get('gestorResiduos')){
        body.gestorResiduos = this.datosGeneralesForm.get('gestorResiduos')?.value;
      }else{
        body.gestorResiduos = false;
      }

      if(this.datosGeneralesForm.get('acondicionador')){
        body.acondicionadorEnvase = this.datosGeneralesForm.get('acondicionador')?.value;
      }else{
        body.acondicionadorEnvase = false;
      }
      if (this.canViewResource('PO-ENV-GEST')) {
        body.acuerdoEnvalora =
          this.datosGeneralesForm.get('acuerdoEnv')?.value === 'Si'
            ? true
            : this.datosGeneralesForm.get('acuerdoEnv')?.value === 'No'
              ? false
              : null;
      }

      body.fechaBaja = (this.datosGeneralesForm.get('fechaBaja')?.value) ? moment(new Date(this.datosGeneralesForm.get('fechaBaja')?.value)).format('YYYY-MM-DD') : '';
      body.abonoDeposito = this.datosGeneralesForm.get('abonoDeposito')?.value;
      body.autorizacionComuniaciones = this.datosGeneralesForm.get('autorizacionComuniaciones')?.value;
      if(body.gestorResiduos && body.numInscripcion1 && body.numInscripcion2 && body.numInscripcion3){
        body.numerosInscripcionAdicionales = this.datosGeneralesForm.value.n_inscrip.filter((value:any) => !!value);
      }else{
        body.numerosInscripcionAdicionales = [];
      }
      if (this.datosGeneralesForm.get('acondicionador')?.value === true) {
        body.convenioEnvalora =
          this.datosGeneralesForm.get('convenioEnvalora')?.value === 'Si'
            ? true
            : false
        body.fechaFinConvenio = (this.datosGeneralesForm.get('fechaFinConvenio')?.value) ? moment(new Date(this.datosGeneralesForm.get('fechaFinConvenio')?.value)).format('YYYY-MM-DD') : '';
        body.fechaFirmaConvenio = (this.datosGeneralesForm.get('fechaFirmaConvenio')?.value) ? moment(new Date(this.datosGeneralesForm.get('fechaFirmaConvenio')?.value)).format('YYYY-MM-DD') : '';
      }
      if(this.canEditCargaMasiva()){
        body.cargaMasiva = this.datosGeneralesForm.get('cargaMasiva')?.value;
      }
      this.gestoresResiduosControllerService
        .editById4(this.gestorInfo.id!, body)
        .subscribe({
          next: (response: any) => {
            this.snackBarSrv.showSnackBar(
              'Datos generales guardados correctamente',
              'success'
            );
            this.spinnerSrv.loadingHide();
            this.refrescarGestorEvent.emit(true);
          },
          error: (err) => {
            let mensaje = "Ha ocurrido un error al guardar los datos generales: " + err.error?.cause;
            this.snackBarSrv.showSnackBar(
              mensaje,
              'error'
            );
            this.spinnerSrv.loadingHide();
          },
        });
    } else {
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
    }
  }

  tipoDocumentoSel(idTipoDoc: string) {
    this.datosGeneralesForm.get('codigoDocumento')?.clearValidators();
    if (idTipoDoc === 'NIF') {
      this.datosGeneralesForm
        .get('codigoDocumento')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.nifPattern),
        ]);
    } else if (idTipoDoc === 'DNI') {
      this.datosGeneralesForm
        .get('codigoDocumento')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.dniPattern),
        ]);
    } else if (idTipoDoc === 'NIE') {
      this.datosGeneralesForm
        .get('codigoDocumento')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.niePattern),
        ]);
    }
    this.datosGeneralesForm.get('codigoDocumento')?.updateValueAndValidity();
    this.datosGeneralesForm.get('codigoDocumento')?.markAsTouched();
  }

  controlGeneralForm() {
    if (this.canAccessContinuarAll() || this.canAccessGuardar()) {
      this.controlFormEnable();
    } else {
      this.controlFormDisable();
    }
    this.datosGeneralesForm.get('acuerdoEnv')?.disable();
  }

  controlFormDisable() {
    this.datosGeneralesForm.disable();
  }

  controlFormEnable() {
    this.datosGeneralesForm.enable();
    this.datosGeneralesForm.get('fechaBajaEnvanet')?.disable();
    this.datosGeneralesForm.get('fechaAltaFinalizada')?.disable();
    this.datosGeneralesForm.get('acuerdoEnv')?.disable();
    this.updateAcondicionadorEditability();
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.datosGeneralesForm.controls[controlName].hasError(errorName) &&
      this.datosGeneralesForm.controls[controlName].touched
    );
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.datosGeneralesForm.controls[controlName]?.touched ||
        this.datosGeneralesForm.controls[controlName]?.dirty) &&
      this.datosGeneralesForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  onConvenioChange(item: any): void {
    const convenioEnvalora = this.datosGeneralesForm.get('convenioEnvalora')?.value;
    const fechaFinConvenioControl = this.datosGeneralesForm.get('fechaFinConvenio');
    const fechaFirmaConvenioControl = this.datosGeneralesForm.get('fechaFirmaConvenio');

    if (convenioEnvalora === 'Si' && this.canViewAgreement()) {
      // fechaFinConvenioControl?.setValidators([Validators.required]);
      fechaFirmaConvenioControl?.setValidators([Validators.required]);
      this.firmaObligatoria = true;
    } else {
      fechaFinConvenioControl?.clearValidators();
      fechaFirmaConvenioControl?.clearValidators();
      this.firmaObligatoria = false;
    }
    fechaFinConvenioControl?.updateValueAndValidity();
    fechaFirmaConvenioControl?.updateValueAndValidity();
    this.updateAcondicionadorEditability();
  }

  onConvenioDateChange(): void {
    this.updateAcondicionadorEditability();
  }

  onGestorAcondicionadorChange(): void {
    const acondicionador = this.datosGeneralesForm.get('acondicionador')?.value;
    const gestor = this.datosGeneralesForm.get('gestorResiduos')?.value;
    const nInscripControl = this.datosGeneralesForm.get('n_inscrip_1');
    const abonoDepositoControl = this.datosGeneralesForm.get('abonoDeposito');

    if(acondicionador === true){
      abonoDepositoControl?.setValidators([Validators.required]);
    }else{
      abonoDepositoControl?.clearValidators();
    }
    if (gestor === false) {
      nInscripControl?.clearValidators();
      nInscripControl?.setValidators([Validators.maxLength(255)]);
    } else {
      nInscripControl?.setValidators([Validators.required, Validators.maxLength(255)]);
    }
    nInscripControl?.updateValueAndValidity();
    abonoDepositoControl?.updateValueAndValidity();
  }

  canAccessContinuarAll(): boolean {
    return (
      this.authService.can(
        'poseedores-gestor-detalle',
        'access-b-guardar-continuar'
      ) && this.gestorInfo?.gestoresResiduosEstado?.id == 1
    );
  }

  canAccessGuardar() {
    return (
      this.authService.can('poseedores-gestor-detalle', 'access-b-guardar') &&
      this.gestorInfo?.gestoresResiduosEstado &&
      [1, 2].includes(this.gestorInfo?.gestoresResiduosEstado?.id!)
    );
  }

  canAccessDate(): boolean {
    return (
      this.authService.can('poseedores-gestor-detalle', 'udpate-baja') &&
      this.gestorInfo?.gestoresResiduosEstado &&
      ![1].includes(this.gestorInfo?.gestoresResiduosEstado?.id!)
    );
  }

  showClearButton(formName: string): boolean {
    return this.datosGeneralesForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.datosGeneralesForm.get(formName)?.setValue(null);
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  canViewAgreement(): boolean {
    return this.canViewResource('PO-ENV-GEST');
  }

  private isDateBeforeToday(dateValue: any): boolean {
    if (!dateValue) {
      return false;
    }

    const dateToCheck = moment(dateValue).startOf('day');
    if (!dateToCheck.isValid()) {
      return false;
    }

    return dateToCheck.isBefore(moment().startOf('day'));
  }

  private shouldDisableAcondicionadorByConvenio(): boolean {
    const convenioEnvalora = this.datosGeneralesForm.get('convenioEnvalora')?.value;
    const fechaFinConvenio = this.datosGeneralesForm.get('fechaFinConvenio')?.value;

    if (convenioEnvalora !== 'Si') {
      return false;
    }

    return !fechaFinConvenio || !this.isDateBeforeToday(fechaFinConvenio);
  }

  private updateAcondicionadorEditability(): void {
    const acondicionadorControl = this.datosGeneralesForm.get('acondicionador');
    if (!acondicionadorControl) {
      return;
    }

    const canEditForm = this.canAccessContinuarAll() || this.canAccessGuardar();
    if (!canEditForm) {
      acondicionadorControl.disable({ emitEvent: false });
      return;
    }

    if (this.shouldDisableAcondicionadorByConvenio()) {
      acondicionadorControl.disable({ emitEvent: false });
    } else {
      acondicionadorControl.enable({ emitEvent: false });
    }
  }

  gestorAcondicionadorValidator() {
    return (formGroup: FormBuilder) => {
      const gestorResiduos = this.datosGeneralesForm?.get('gestorResiduos')?.value;
      const acondicionador = this.datosGeneralesForm?.get('acondicionador')?.value;

      if (!gestorResiduos && !acondicionador) {
        return { gestorAcondicionadorChecked: true };
      }

      return null;
    };
  }

  get nInscrip(): FormArray<FormControl<string | null>> {
    return this.datosGeneralesForm.get('n_inscrip') as FormArray;
  }

  addInscripcion() {
    this.nInscrip.push(
      this.formBuilder.control(null, [Validators.maxLength(255)])
    );
  }

  removeInscripcion(index: number) {
    if (this.nInscrip.length > 0) {
      this.nInscrip.removeAt(index);
    }
  }

  controlNInscripHasError(index: number, error: string): boolean {
    return this.nInscrip.at(index).hasError(error);
  }

  cargarDatosNInscript(numerosInscripcionAdicionales:any){
    if(numerosInscripcionAdicionales){
      let inscripArray: any[] = [];
      numerosInscripcionAdicionales.forEach((valor:any) => {
        if(valor && valor != ''){
          inscripArray.push(
            this.formBuilder.control(valor, [Validators.required, Validators.maxLength(255)])
          );
        }
      });
      this.datosGeneralesForm.setControl('n_inscrip', this.formBuilder.array(inscripArray));
    }

  }

  canViewCargaMasiva(): boolean {
    return this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS');
  }

  canEditCargaMasiva(): boolean {
    return this.canViewResource('PO-ENV-GEST');
  }

    onInput(controlName: string, event: any) {
    const control = this.datosGeneralesForm.get(controlName)
    const input = event.target as HTMLInputElement;
    control?.markAsTouched();
    control?.markAsDirty();
  }

}
